import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = '查看全部', icon }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
          {icon && (
            <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
              <i className={`${icon} text-base`} />
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-xs md:text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-xs md:text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}